import React from 'react';

function BackToTopButton({ showBackToTop, enableBackToTop, onClick }) {
  if (!showBackToTop || !enableBackToTop) {
    return null;
  }

  return (
    <button
      className="back-to-top"
      onClick={onClick}
      aria-label="Return to top"
      title="Return to top"
    >
      ↑ Top
    </button>
  );
}

export default BackToTopButton;
